var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"height":"165px","width":"100%"},attrs:{"id":_vm.namespace + '-chartStatsDiv'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }